export default {
  highcharts: 'Chart',
  highstock: 'StockChart',
  highmaps: 'Map',
  'highcharts-renderer': 'Renderer'
};



//////////////////
// WEBPACK FOOTER
// ./~/vue-highcharts/src/constructors.js
// module id = 383
// module chunks = 12